import { assertIsNumber, assertIsTrue } from '../../lib/test-and-assert/assert-base';

var formatting = {
    fileSize: function (bytes) {
        var GB_SIZE = 1073741824;
        var MB_SIZE = 1048576;
        var KB_SIZE = 1024;

        if (typeof bytes !== 'number') {
            return '';
        }

        if (bytes >= GB_SIZE) {
            return (bytes / GB_SIZE).toFixed(2) + ' GB';
        }

        if (bytes >= MB_SIZE) {
            return (bytes / MB_SIZE).toFixed(2) + ' MB';
        }

        if (bytes >= KB_SIZE) {
            return (bytes / KB_SIZE).toFixed(2) + ' KB';
        }

        if (bytes !== 1) {
            return bytes.toFixed(2) + ' bytes';
        }

        return bytes.toFixed(2) + ' byte';
    },
    bitrate: function (bits) {
        if (typeof bits !== 'number') {
            return '';
        }
        if (bits >= 1000000000) {
            return (bits / 1000000000).toFixed(2) + ' Gbit/s';
        }
        if (bits >= 1000000) {
            return (bits / 1000000).toFixed(2) + ' Mbit/s';
        }
        if (bits >= 1000) {
            return (bits / 1000).toFixed(2) + ' kbit/s';
        }
        return bits.toFixed(2) + ' bit/s';
    },
    time: function (seconds) {
        assertIsNumber(seconds);
        var date = new Date(seconds * 1000);
        var days = Math.floor(seconds / 86400);

        var d = days ? days + 'd ' : '';
        var h = ('0' + date.getUTCHours()).slice(-2);
        var m = ('0' + date.getUTCMinutes()).slice(-2);
        var s = ('0' + date.getUTCSeconds()).slice(-2);

        if (seconds < 60 * 60) {
            return m + ':' + s;
        }

        return d + h + ':' + m + ':' + s;
    },
    percentage: function (floatValue) {
        assertIsNumber(floatValue);
        // add some small buffer around 0...1
        assertIsTrue(floatValue >= -0.1);
        assertIsTrue(floatValue <= 1.1);
        return (floatValue * 100).toFixed(0);
    },
};

export { formatting };
